import { DateField } from '@prismicio/client';

export const changeDataFormat = (date: DateField) => {
  if (date) {
    const newDate = new Date(date);
    const formattedDate = newDate.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });

    return formattedDate?.split('/').join('.');
  }
  return date;
};
